export default {
  features: {
    problemCaseUpdateStatus: {
      placeholder: 'Holatlardan birini tanlang',
      processing: 'Jarayonda',
      completed: 'Bajarildi',
    },
  },
};
